import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function PolitykaPrywatnosciPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 pb-10 md:pb-14">
          <div className="px-4 md:px-8 lg:px-12 max-w-3xl mx-auto">
            <Breadcrumb />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary-500 mb-3 block">Dokumenty</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
              Polityka prywatności
            </h1>
            <p className="text-sm text-foreground-500 mb-8">Ostatnia aktualizacja: 25 lipca 2026</p>
          </div>
        </section>

        <section className="pb-16 md:pb-24">
          <div className="px-4 md:px-8 lg:px-12 max-w-3xl mx-auto">
            <div className="flex flex-col gap-8 text-sm md:text-base text-foreground-700 leading-relaxed">

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">1. Informacje ogólne</h2>
                <p>
                  Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych przekazanych przez Użytkowników w związku z korzystaniem z serwisu internetowego <strong>kredytpodkarpacie.pl</strong>.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">2. Administrator danych osobowych</h2>
                <p className="mb-2">Administratorem Państwa danych osobowych jest:</p>
                <p>
                  <strong>Jan Wojdyła – Ekspert Kredytowy</strong><br />
                  ul. Dworcowa 11A, 38-500 Sanok<br />
                  NIP: [dane administratora]<br />
                  E-mail: biuro@kredytpodkarpacie.pl<br />
                  Telefon: 698 084 044
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">3. Zakres i cel przetwarzania danych</h2>
                <p className="mb-2">Przetwarzamy dane osobowe w następujących celach:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li>Odpowiedzi na zapytania przesłane przez formularz kontaktowy (podstawa: prawnie uzasadniony interes administratora)</li>
                  <li>Świadczenia usług eksperta kredytowego (podstawa: wykonanie umowy lub działania przed jej zawarciem)</li>
                  <li>Prowadzenia korespondencji z klientami (podstawa: prawnie uzasadniony interes)</li>
                  <li>Wypełnienia obowiązków prawnych ciążących na administratorze</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">4. Jakie dane zbieramy?</h2>
                <p className="mb-2">Zbieramy wyłącznie dane niezbędne do realizacji usług doradztwa kredytowego:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li>Imię i nazwisko</li>
                  <li>Adres e-mail</li>
                  <li>Numer telefonu</li>
                  <li>Informacje dotyczące sytuacji finansowej (dochody, zobowiązania) — wyłącznie za zgodą klienta i w celu analizy zdolności kredytowej</li>
                  <li>Dane zawarte w korespondencji e-mail i formularzach kontaktowych</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">5. Okres przechowywania danych</h2>
                <p>
                  Dane osobowe przechowujemy przez okres niezbędny do realizacji celów, dla których zostały zebrane, oraz zgodnie z obowiązującymi przepisami prawa — nie dłużej niż 5 lat od zakończenia współpracy lub ostatniego kontaktu.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">6. Prawa osób, których dane dotyczą</h2>
                <p className="mb-2">Każda osoba, której dane przetwarzamy, ma prawo do:</p>
                <ul className="list-disc pl-5 flex flex-col gap-1.5">
                  <li>Dostępu do swoich danych osobowych</li>
                  <li>Sprostowania (poprawiania) danych</li>
                  <li>Usunięcia danych (prawo do bycia zapomnianym)</li>
                  <li>Ograniczenia przetwarzania</li>
                  <li>Przenoszenia danych</li>
                  <li>Wniesienia sprzeciwu wobec przetwarzania</li>
                  <li>Wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych</li>
                </ul>
                <p className="mt-2">W celu skorzystania z powyższych praw prosimy o kontakt na adres e-mail: <strong>biuro@kredytpodkarpacie.pl</strong>.</p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">7. Pliki cookies</h2>
                <p>
                  Serwis wykorzystuje pliki cookies wyłącznie w celu zapewnienia prawidłowego działania strony (techniczne cookies). Nie stosujemy cookies marketingowych ani śledzących bez wyraźnej zgody użytkownika. Szczegółowe informacje dotyczące plików cookies dostępne są w banerze cookies wyświetlanym przy pierwszej wizycie na stronie.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">8. Przekazywanie danych podmiotom trzecim</h2>
                <p>
                  Państwa dane osobowe mogą być przekazywane wyłącznie podmiotom współpracującym przy realizacji usługi eksperta kredytowego (banki i instytucje finansowe) — zawsze na podstawie odrębnej zgody klienta i wyłącznie w zakresie niezbędnym do złożenia wniosku kredytowego.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">9. Bezpieczeństwo danych</h2>
                <p>
                  Administrator stosuje odpowiednie środki techniczne i organizacyjne zapewniające bezpieczeństwo przetwarzanych danych osobowych, w szczególności zabezpieczenia przed nieuprawnionym dostępem, utratą czy zniszczeniem.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">10. Zmiany w polityce prywatności</h2>
                <p>
                  Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. O wszelkich zmianach będziemy informować poprzez publikację nowej wersji na stronie internetowej.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">11. Kontakt</h2>
                <p>
                  Wszelkie pytania dotyczące Polityki Prywatności prosimy kierować na adres e-mail: <strong>biuro@kredytpodkarpacie.pl</strong> lub telefonicznie: <strong>698 084 044</strong>.
                </p>
              </div>

            </div>

            <div className="mt-12 pt-8 border-t border-background-200 text-center">
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-up-line" />
                Powrót na górę strony
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
